import { render, staticRenderFns } from "./BottomSubMenu.vue?vue&type=template&id=18d61932&scoped=true"
import script from "./BottomSubMenu.vue?vue&type=script&lang=js"
export * from "./BottomSubMenu.vue?vue&type=script&lang=js"
import style0 from "./BottomSubMenu.vue?vue&type=style&index=0&id=18d61932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d61932",
  null
  
)

export default component.exports